import { render, staticRenderFns } from "./workflowInstanceEditPanel.vue?vue&type=template&id=4b964d8a&scoped=true&"
import script from "./workflowInstanceEditPanel.vue?vue&type=script&lang=js&"
export * from "./workflowInstanceEditPanel.vue?vue&type=script&lang=js&"
import style0 from "./workflowInstanceEditPanel.vue?vue&type=style&index=0&id=4b964d8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b964d8a",
  null
  
)

export default component.exports